import React, { useEffect, useState } from "react";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import { HiOutlinePlus } from "react-icons/hi";
import { Menu } from "@headlessui/react";
import { useGetAllTenantUserMutation } from "../../../features/tenant/tenantAuth/tenantAuthApi";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { toast } from "react-hot-toast";
import { hasPermission } from "../../../utils/hasPermission";
import { getVendorName } from "../../../utils/getVendorName";
import ExportCSV from "../../../components/ExportCsv/ExportCsv";
import CustomExport from "../../../components/CustomExport/CustomExport";
import {
  useAddVendorProductMutation,
  useCountVendorProductsMutation,
  useDeleteVendorProductMutation,
  useFetchvendorProductsMutation,
} from "../../../features/tenant/VendorProductMapping/vendorProductApi";
import SelectComponentWithSearch from "../../../components/Tenant/SelectComponentWIthSearch/SelectComponentWithSearch";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { useFetchProductsMutation } from "../../../features/tenant/products/productsApi";
import InputComponent from "../../../components/Tenant/InputComponent/InputComponent";

const UserProductMapping = () => {
  const navigate = useNavigate();
  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
    .color_shades;
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [productList, setProductList] = useState([]);
  const [userList, setUserList] = useState([]);
  const initialRequest = {
    vendor_code: "",
    product_code: "",
    email: "",
    mobile: "",
    limit: 10,
    offset: 0,
  };
  const [request, setRequest] = useState(initialRequest);
  const [product, setProduct] = useState();
  const [vendor, setVendor] = useState();
  const [vendorCode, setVendorCode] = useState("");
  const [
    getAllTenantUser,
    {
      data: getAllTenantUserData,
      isLoading: getAllTenantUserIsLoading,
      isError: getAllTenantUserIsError,
      error: getAllTenantUserError,
    },
  ] = useGetAllTenantUserMutation();

  const [
    getVendorProduct,
    {
      data: getVendorProductData,
      isLoading: getVendorProductIsLoading,
      isError: getVendorProductIsError,
      error: getVendorProductError,
    },
  ] = useFetchvendorProductsMutation();

  const [
    countVendorProduct,
    {
      data: countVendorProductData,
      isLoading: countVendorProductIsLoading,
      isError: countVendorProductIsError,
      error: countVendorProductError,
    },
  ] = useCountVendorProductsMutation();

  const [
    addVendorProduct,
    {
      data: addVendorProductData,
      isLoading: addVendorProductIsLoading,
      isError: addVendorProductIsError,
      error: addVendorProductError,
    },
  ] = useAddVendorProductMutation();
  const [
    fetchProducts,
    {
      data: productsData,
      isLoading: productsIsLoading,
      isError: productsIsError,
      error: productsError,
    },
  ] = useFetchProductsMutation();
  const [
    getVendorProductCsv,
    {
      data: getVendorProductCsvData,
      isLoading: getVendorProductCsvIsLoading,
      isError: getVendorProductCsvIsError,
      error: getVendorProductCsvError,
    },
  ] = useFetchvendorProductsMutation();
  const clearFilters = () => {
    setRequest(initialRequest);
  };

  useEffect(() => {
    if (
      request.email === "" &&
      request.product_code === "" &&
      request.vendor_code === "" &&
      request.mobile === ""
    ) {
      getAllVendorProducts();
      countAllVendorProducts();
    }
  }, [request]);

  const getAllUsers = () => {
    getAllTenantUser({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        limit: null,
        offset: null,
      },
    });
  };

  useEffect(() => {
    if (addVendorProductData) {
        getAllVendorProducts();
        countAllVendorProducts();
      toast.success("Product Assigned to the user");
      setShowModal(false);
    }
   else if (addVendorProductData) {
      toast.error("Error in assigning product to user");
    }
  }, [addVendorProductData, addVendorProductError]);

  useEffect(() => {
    //   const hasViewPermission = hasPermission("productAssignedTo");
    //   if (!hasViewPermission) {
    //     navigate(`/genefied/${getVendorName()}/`);
    //   }
  }, []);

  const fetchProductsFunction = () => {
    fetchProducts({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        limit: null,
        offset: null,
      },
    });
  };

  const addVendorFunction = (e) => {
    e.preventDefault();

    if (!product?.name) {
      toast.error("Please Select Product Code");
      return;
    }
    if (!vendor?.name) {
      toast.error("Please Select User Email");
      return;
    }

    if (!vendor?.mobile) {
      toast.error("Please Select User Email");
      return;
    }

    if (!vendorCode) {
      toast.error("Please Enter Vendor Code");
      return;
    }
    const data = {
      productCode: product.name,
      email: vendor.name,
      mobile: vendor.mobile,
      vendorCode,
    };
    const userTenant = JSON.parse(sessionStorage.getItem("userTenant"));
    if (userTenant) {
      data["userId"] = userTenant.id;
      data["userName"] = userTenant.name;
    }

    addVendorProduct({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: data,
    });
  };
  useEffect(() => {
    if (productsData) {
      if (productsData?.body?.products) {
        const products = productsData.body.products.map((e) => {
          return {
            ...e,
            product_name: e.name,
            name: e.product_code,
          };
        });
        setProductList(products);
      }
    }
  }, [productsData]);

  useEffect(() => {
    if (getAllTenantUserData?.body?.users) {
      const users = getAllTenantUserData.body.users.map((e) => {
        return {
          ...e,
          name: e.email,
        };
      });
      setUserList(users);
    }
  }, [getAllTenantUserData]);

  useEffect(() => {
    if (showModal == true) {
      fetchProductsFunction();
      getAllUsers();
    }
  }, [showModal]);
  const [csvData, setCsvData] = useState(null);
  useEffect(() => {
    if (getVendorProductCsvData && getVendorProductCsvData?.body?.s) {
      setCsvData(getVendorProductCsvData.body.s);
    }

    if (getVendorProductCsvError) {
      setCsvData(null);
    }
  }, [getVendorProductCsvData, getVendorProductCsvError]);

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
  };

  const getAllVendorProducts = () => {
    getVendorProduct({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
    });
  };

  const countAllVendorProducts = () => {
    const modifiedRequest = {
      ...request,
      limit: null,
      offset: null,
    };
    countVendorProduct({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: modifiedRequest,
    });
  };

  const [
      deleteVendorProduct,
      {
        data: deleteVendorProductData,
        isLoading: deleteVendorProductIsLoading,
        isError: deleteVendorProductIsError,
        error: deleteVendorProductError,
      },
    ] = useDeleteVendorProductMutation();
  
    const deleteUser = (data) => {
      deleteVendorProduct({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        id: data.id,
      });
    };
    useEffect(() => {
      if (deleteVendorProductData) {
        toast.success("Product User Deleted Successfully !!");
        getAllVendorProducts();
      countAllVendorProducts();
      }
      if (deleteVendorProductError) {
        toast.error("Error in Deleting Product User");
      }
    }, [deleteVendorProductData, deleteVendorProductError]);
  const columns = [
    {
      name: "SNo",
      selector: (row, idx) => idx + 1,
      sortable: true,
      width: "80px",
    },
    {
      name: "Product Code",
      selector: (row) => row.product_code,
      sortable: true,
      width: "160px",
    },
    {
      name: "Email Id",
      selector: (row) => row.email,
      sortable: true,
      width: "250px",
    },
    {
      name: "Phone No",
      selector: (row) => row.mobile,
      sortable: true,
      width: "120px",
    },
    {
      name: "Vendor Code",
      selector: (row) => row.vendor_code,
      sortable: true,
      width: "150px",
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex justify-center space-x-2 m-auto">
          <>
            <button
              onClick={() => deleteUser(row)}
              className="flex justify-center items-center rounded bg-danger px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#dc4c64] transition duration-150 ease-in-out hover:bg-danger-600 hover:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] focus:bg-danger-600 focus:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] focus:outline-none focus:ring-0 active:bg-danger-700 active:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(220,76,100,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)]"
            >
              <AiOutlineDelete className="mr-1" />
              Delete
            </button>
          </>
        </div>
      ),

      width: "20%",
    },
  ];

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Product Assign To
            <LinksComponent />
          </div>

          <div className=" p-3">
            <div className=" bg-white shadow rounded-lg">
              <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                <div className="flex  space-x-2 justify-between">
                  <div className="w-52 h-10">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Product Code
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Product Code..."
                        required
                        value={request.product_code}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, name: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-52 h-10">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Vendor Code
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Vendor Code..."
                        required
                        value={request.vendor_code}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, vendor_code: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-52 h-10 ">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Email
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Email ..."
                        required
                        value={request.email}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, email: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-52 h-10">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Mobile
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Mobile No..."
                        required
                        value={request.mobile}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, mobile: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex flex-row gap-2 h-10">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        &nbsp;
                      </label>
                      <button
                        className="btn btn-outline-primary pdbtn_all clear-both float-right "
                        onClick={() => {
                          getAllVendorProducts();
                          countAllVendorProducts();
                        }}
                      >
                        Search
                      </button>
                    </div>
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        &nbsp;
                      </label>
                      <button
                        className="btn btn-outline-primary pdbtn_all clear-both float-right whitespace-nowrap"
                        onClick={() => {
                          clearFilters();
                        }}
                      >
                        Clear Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <DataTableComponent
              keyField={(row) => row.SNo}
                columns={columns}
                data={getVendorProductData && getVendorProductData.body.assignedProducts}
                loading={getVendorProductIsLoading}
                totalRows={
                  countVendorProductData &&
                  countVendorProductData.body.total_assigned_products
                }
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              ></DataTableComponent>
              <div
                className="fixed bottom-0 right-16 w-16 h-16 mr-10 mb-2 cursor-pointer"
                id="box_btn"
              >
                <div className="text-right">
                  <Menu className="relative inline-block text-left">
                    <div>
                      <Menu.Button
                        onClick={() => setShowModal(true)}
                        className="inline-flex justify-cente w-12 h-12 rounded-full text-sm font-medium text-white hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 "
                        style={{ backgroundColor: `${primaryColor["700"]}` }}
                      >
                        <HiOutlinePlus className="w-full h-full p-3" />
                      </Menu.Button>
                    </div>
                  </Menu>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <ModalComponent
          size={"sm"}
          data={"nadnandand"}
          show={showModal}
          setShow={setShowModal}
        >
          <div className="w-full p-4 ">
            <div className="w-full flex-col justify-center ">
              <div className=" items-center justify-center w-full mb-6">
                <SelectComponentWithSearch
                  title={"Product"}
                  name={"Select Product*"}
                  placeholder={"Select Product"}
                  type={"text"}
                  selected={product}
                  setSelected={setProduct}
                  dataArr={productList}
                  required={true}
                />
              </div>

              <div className=" items-center justify-center w-full mb-6">
                <SelectComponentWithSearch
                  title={"Email"}
                  name={"Select Vendor Email*"}
                  placeholder={"Select Vendor Email"}
                  type={"text"}
                  selected={vendor}
                  setSelected={setVendor}
                  dataArr={userList}
                  required={true}
                />
              </div>

              <div className=" items-center justify-center w-full mb-6">
                <InputComponent
                  name={"Vendor Code"}
                  type={"text"}
                  placeholder={"Vendor Code"}
                  value={vendorCode}
                  setValue={setVendorCode}
                  required={true}
                />
              </div>
            </div>

            <div className="flex justify-center">
              <button
                type="submit"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                onClick={(e) => addVendorFunction(e)}
              >
                Add
              </button>
            </div>
          </div>
        </ModalComponent>
      )}
    </>
  );
};

export default UserProductMapping;
